import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from './Icons';
export function AgitationSection() {
  const comparisons = [{
    have: '10 apps de devocional',
    feel: 'Vacío espiritual el lunes por la mañana'
  }, {
    have: 'Cursos bíblicos online',
    feel: 'Ansiedad que la teología no calma'
  }, {
    have: 'Frases motivacionales con versículos',
    feel: 'Oraciones que "rebotan en el techo"'
  }, {
    have: 'Años de membresía en la iglesia',
    feel: 'Sensación de ser un extraño frente a Dios'
  }];
  return <section className="bg-dark-texture text-cream py-24 px-4" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-18">
          <FlameIcon className="w-12 h-12 text-accent-red mx-auto mb-6" data-id="element-19" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-20">
            El Dolor Que Nadie Nombra
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-21">
            Seré directo contigo: En 2026 tenemos más acceso a sermones,
            podcasts y versiones de la Biblia que cualquier generación en la
            historia. Y sin embargo...
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-22">
          {comparisons.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-light border border-white/10 p-6 rounded-lg flex flex-col justify-between" data-id="element-23">
              <div className="mb-4" data-id="element-24">
                <span className="text-xs font-bold tracking-wider text-gold uppercase mb-2 block" data-id="element-25">
                  Lo que TENEMOS
                </span>
                <p className="text-lg font-serif" data-id="element-26">{item.have}</p>
              </div>
              <div className="pt-4 border-t border-white/10" data-id="element-27">
                <span className="text-xs font-bold tracking-wider text-accent-red uppercase mb-2 block" data-id="element-28">
                  Lo que SENTIMOS
                </span>
                <p className="text-lg font-serif text-cream/70" data-id="element-29">{item.feel}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto text-center space-y-6 text-lg text-cream/90" data-id="element-30">
          <p className="text-2xl font-serif font-bold text-gold" data-id="element-31">¿Por qué?</p>
          <p data-id="element-32">
            Porque hemos confundido acumular datos sobre Dios con conocer a la
            Persona de Dios. Son dos actividades radicalmente distintas.
          </p>
          <p data-id="element-33">
            Puedes leer la biografía de alguien durante 20 años y seguir siendo
            un completo extraño para esa persona.
          </p>

          <div className="bg-olive/30 border border-olive p-8 rounded-lg my-12" data-id="element-34">
            <p className="font-bold text-xl mb-4 text-white" data-id="element-35">
              Y aquí está la parte que duele de verdad:
            </p>
            <p className="mb-6" data-id="element-36">
              El agotamiento espiritual que sientes no es señal de poca fe. Es
              la consecuencia inevitable de intentar cumplir requisitos para un
              Dios que ya pagó la cuenta.
            </p>
            <p className="font-serif italic text-gold text-xl" data-id="element-37">
              "Mi yugo es fácil y ligera mi carga." — Mateo 11:30
            </p>
          </div>

          <p className="text-2xl font-serif" data-id="element-38">
            Si tu fe se siente como una carga aplastante... es que estás
            cargando la religión.{' '}
            <span className="text-gold font-bold" data-id="element-39">No a Cristo.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}